import cn from 'classnames';
import {Dispatch, SetStateAction} from 'react';
import CustomRadio from '../../../../components/mazraeKit/customRadio';
import {MyCreditsTabsType} from '../MyCreditsPage';
import {baseBadgeClassName, greenBadgeStyles} from '../helper/getCashBackBadge';

interface IProps {
  loan: ITakenLoan;
  isSelected: boolean;
  setSelectedLoanGuid: Dispatch<SetStateAction<string>>;
  tabType?: MyCreditsTabsType;
}

const TakenLoanCard = ({
  loan,
  isSelected,
  setSelectedLoanGuid,
  tabType = 'current',
}: IProps) => {
  const isPaid = loan.is_paid;

  const toggleLoanCard = () => {
    if (tabType === 'paid') return;
    setSelectedLoanGuid(prev => (prev === loan.guid ? '' : loan.guid));
  };

  return (
    <div
      id={loan.guid}
      className="flex min-h-[120px] gap-2 p-3 border-[1px] rounded-2xl border-gray-100 bg-gray-50 items-start"
      onClick={toggleLoanCard}
    >
      {tabType === 'current' && (
        <CustomRadio
          title=""
          inputClassname="size-4"
          value={loan.guid}
          checked={isSelected}
          onChange={toggleLoanCard}
          onClick={e => e.stopPropagation()}
          name="loan"
        />
      )}
      <div className="flex flex-col w-full gap-2">
        <div className="flex items-center gap-2">
          <img src={loan.bank_logo} className="object-contain w-5 h-5" />
          <span className="text-sm font-medium text-gray-900">
            وام بانک {loan.bank_title}
          </span>
        </div>

        <div className="flex items-center gap-1">
          <span className="text-lg font-medium text-gray-800">
            {loan.loan_type_amount.toLocaleString()}
          </span>
          <span className="text-sm font-normal text-gray-700">تومان</span>
        </div>

        <PaidStatusBadge isPaid={isPaid} />
      </div>
    </div>
  );
};

export default TakenLoanCard;

// ------------------------------------------------------------

const PaidStatusBadge = ({isPaid}: {isPaid: boolean}) => {
  const badgeText = isPaid ? 'تسویه شده' : 'دریافت شده';

  return (
    <div className={cn(baseBadgeClassName, greenBadgeStyles)}>{badgeText}</div>
  );
};
